import { getFolderProjectId } from './bankSidebarCategories';
import { isProjectTypeProjectBankFolder } from './projectBankForms';

/**
 * The root folder of a project among loaded bank folders: the project-type
 * folder (key depth of a project, see isProjectTypeProjectBankFolder) whose
 * project is the one asked for. The tree of the open bank is rooted at the
 * route project's; sub-projects' roots sit under it as ordinary rows.
 * @param {Array<Object>} folders loaded folder file permissions
 * @param {string} projectId
 * @returns {Object|null}
 */
export const findProjectRootFolder = (folders, projectId) => {
  if (!projectId || !Array.isArray(folders)) return null;

  return (
    folders.find(
      (folder) =>
        folder &&
        !folder.deletedAt &&
        isProjectTypeProjectBankFolder(folder) &&
        getFolderProjectId(folder) === projectId
    ) || null
  );
};
